import React from "react";
import { fetchProductsApi } from "../../apiCalls/ApiCall";
import { setProducts } from "../stores/productSlice";

export const fetchProducts = () => {
  return async (dispatch) => {
    try {
      const products = await fetchProductsApi();
      dispatch(setProducts(products));
    } catch (error) {
      console.log("error ayoki");
    }
  };
};
